<template>
    <div class="show">
        <!-- 通过condtionSkip控制条件显示 -->
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <div class="add-condition" :style="{marginBottom: topics.length ? '0' : '1rem'}">
            <span class="tip">当前题目</span>
            <div class="topic">
                <span class="topic-title">{{topicName || ''}}</span>
                <span class="add-btn" @click="addCondition"><me-icon name="plus" style=" vertical-align: middle;"/> 添加条件</span>
            </div>
        </div>
        <ul class="condition-wrap" :class="{'noMore': !moreCondition}">
            <li
                class="item-wrap"
                v-for="(item, index) of topics"
                :key="index"
                 @click="addCondition">
                <ul v-if="item.topicType === 'matrix-rate'">
                    <li v-for="(matrix, matrixIndex) in item.matrixs" :key="matrixIndex">
                        <template v-if="!matrix.conditionSkip">
                            <div class="item">
                                <div class="condition">
                                    <div class="title-wrap">
                                        <span class="topic-title">
                                            {{item.index}}-{{matrixIndex+1}}.<span class="topic-type">{{types[item.topicType]}}</span>{{item.topicName}}
                                        </span>
                                        <img src="../images/del.png" class="del" @click.stop="del(item, matrixIndex)">
                                    </div>
                                    <div class="matrix-title">
                                        <span class="topic-type">{{matrix.type}}</span>{{matrix.title}}:
                                    </div>
                                    <ul class="options">
                                        <li class="option" v-for="(option, i) in matrix.value" :key="i">
                                            {{option}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="tip">
                                    <span>当选中其中任意一个时，出现当前题目</span>
                                </div>
                            </div>
                        </template>
                    </li>
                </ul>
                <div class="item" v-else :style="{marginBottom: item.conditionSkip ? 0 : '0.32rem'}">
                    <template v-if="!item.conditionSkip">
                        <div class="condition">
                            <div class="title-wrap">
                                <span class="topic-title">
                                    {{item.index}}.<span class="topic-type">{{types[item.topicType]}}</span>{{item.topicName}}
                                </span>
                                <img src="../images/del.png" class="del" @click.stop="del(item, index)">
                            </div>
                            <ul class="options">
                                <li class="option" v-for="(option, i) in item.showJsonValue" :key="i">
                                    {{item.topicType === 'rate' ? option : (option === '10000' ? '其他' : item.selectItem[option] && item.selectItem[option].itemKey)}}
                                </li>
                            </ul>
                        </div>
                        <div class="tip" :class="{checkbox: item.topicType==='checkbox'}" @click.stop="clickStop">
                            <div v-if="item.topicType==='checkbox'">
                                <me-cell
                                    :title="rules[item.config||0]"
                                    is-link
                                    class="checkbox-rule"
                                    @click="select(item)"/>
                                <me-popup v-model="showPop" position="bottom">
                                    <me-picker
                                        title=""
                                        show-toolbar
                                        :columns="rules"
                                        :defaultIndex="item.config||0"
                                        @confirm="onConfirm"
                                        @cancel="onCancel"
                                        />
                                </me-popup>
                            </div>
                            <span v-else>当选中其中任意一个时，出现当前题目</span>
                        </div>
                    </template>
                </div>
            </li>
        </ul>
        <div class="topic-relate" v-if="moreCondition">
            <div class="relate-desc">条件为多道题目时，多题之间为:</div>
            <me-cell
                :title="relateList[relateIndex||0]"
                is-link
                class="checkbox-rule"
                @click="selectRelate"/>
            <me-popup v-model="relatePop" position="bottom">
                <me-picker
                    title=""
                    show-toolbar
                    :columns="relateList"
                    :defaultIndex="relateIndex||0"
                    @confirm="relateConfirm"
                    @cancel="relateCancel"
                    />
            </me-popup>
        </div>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import { Questionnaire } from '@/network'
import { addClass2, removeClass2 } from '@/util/status-util'
import { getStorage } from '@/util/common'
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import confirm from '../compontents/confirm.vue'
import browser from '@/util/browser'

export default {
    name: 'show',
    components: { confirm },
    data() {
        return {
            topics: [],
            topic: {},
            title: '显示设置',
            types: {
                'radio': '【单选题】',
                'checkbox': '【多选题】',
                'rate': '【评分题】',
                'nps': '【NPS题】',
                'matrix-rate': '【矩阵评分题】',
            },
            showPop: false,
            rules: [
                '当【选中】其中【任意一个】时，出现当前题目',
                '当【未选中】其中【任意一个】时，出现当前题目',
                '当【选中】其中【全部选项】时，出现当前题目',
                '当【未选中】其中【全部选项】时，出现当前题目',
            ],
            popItem: {},
            moreCondition: false,
            relatePop: false,
            relate: '',
            relateIndex: 0,
            relateList: ['“或”关系（只要满足一个关联条件）', '“且”关系（满足所有关联条件）'],
            isCustomLeft: false,
            topicName: '',
        }
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
        type() {
            return this.$route.params.type
        },
    },
    created() {
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.topicId ? this.getTopic() : this.cacheTopics()
        this.topicName = this.$store.state.topicName
    },
    mixins: [mixin],
    methods: {
        clickStop() {},
        getTopic() {
            const data = {
                tid: this.tid,
                topicId: this.topicId,
            }
            addClass2('body', 'loading')
            Questionnaire.topicInfo(data).then((res) => {
                removeClass2('body', 'loading')
                const { data } = res.data
                this.topic = data[0] || {}
                if (!this.topic.topicName && this.topic.topicType !== 'paragraph') {
                    return
                }
                let showJson = JSON.parse(this.topic.showJson)
                this.relateIndex = showJson ? showJson.relate : 0
                // 上一次设置的内容
                let { showConfirm } = this.$store.state
                if (showConfirm) {
                    let { relate, showJson: showJsonStr } = this.$store.state
                    this.topic.relate = relate
                    this.topic.showJson = showJsonStr
                    showJson = showJsonStr ? JSON.parse(showJsonStr) : showJson
                }
                this.cacheTopics()
                if (!this.topics.length && showJson && showJson.list && showJson.list.length) {
                    // 已设置过，接口请求，处理数据
                    this.getTopics()
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        getTopics() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            addClass2('body', 'loading')
            Questionnaire.getQuestionDetail(data).then((res) => {
                removeClass2('body', 'loading')
                const { data: { topicsList } } = res.data
                this.topics = topicsList
                this.dealTopicData()
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        dealTopicData() {
            let time = 0
            const i = this.topics.findIndex(item => item.topicCode === this.topicId)
            const topics = JSON.parse(JSON.stringify(this.topics))
            const showJson = this.topic.showJson ? JSON.parse(this.topic.showJson) : null
            const newIndexTopicsList = topics.map((item, index) => {
                // 处理题号
                let newIndex = 0
                if (/^paragraph$/.test(item.topicType)) {
                    time += 1
                }
                newIndex = index - time
                // 条件中不显示填空和段落
                index >= i || /^paragraph|text|textarea$/.test(item.topicType) ? item.skip = true : null
                // 处理矩阵评分
                if (item.topicType === 'matrix-rate') {
                    const matrixs = item.matrixs
                    item.matrixs = []
                    item.selectItem.forEach((line, matrixIndex) => {
                        item.matrixs.push({
                            type: '【行标题】',
                            title: line.itemKey,
                            count: item.score / 1,
                            value: matrixs && matrixs[matrixIndex] ? matrixs[matrixIndex].value : [],
                        })
                    })
                }
                item.topicType !== 'matrix-rate' ? item.showJsonValue = item.showJsonValue || [] : null
                // 处理显示条件
                const showObj = showJson ? showJson.list.find(obj => obj.id === item.topicCode) : false
                if (!showObj) return { ...item, index: newIndex + 1 }
                if (showObj.type === 'matrix-rate') {
                    item.matrixs.forEach((matrix, matrixIndex) => {
                        const value = showObj.conditions[matrixIndex] && showObj.conditions[matrixIndex].value
                        value && value.length ? item.show = '1' : null
                        matrix.value = value
                    })
                } else {
                    if (showJson.list && showJson.list.length === 1 && /^(radio|checkbox)$/.test(item.topicType)) {
                        const topic = topics.find(topic => topic.topicCode === showJson.list[0].id)
                        let newList = showJson.list[0].conditions.map((condition, i) => {
                            return topic.selectItem[condition] ? condition : ''
                        })
                        newList = newList.filter(item => item)
                        if (!newList.length){
                            return { ...item, index: newIndex + 1 }
                        }
                    }
                    item.show = '1'
                    item.showJsonValue = showObj.conditions
                    item.topicType === 'checkbox' ? item.config = showObj.config : ''
                }
                return { ...item, index: newIndex + 1 }
            })
            this.relateIndex = showJson ? showJson.relate : 0
            this.dealWidthCondition(newIndexTopicsList)
        },
        cacheTopics() {
            const topics = getStorage('vuex') && getStorage('vuex').showTopicList || []
            const newIndexTopicsList = this.$store.state.showTopicList || topics
            if (!newIndexTopicsList.length) return
            const relate = this.$store.state.relate || getStorage('vuex').relate
            this.relateIndex = relate
            this.dealWidthCondition(newIndexTopicsList)
            removeClass2('body', 'loading')
        },
        dealWidthCondition(newIndexTopicsList) {
            newIndexTopicsList.forEach(item => {
                let topicFlag = !item.skip && item.show && item.showJsonValue && item.showJsonValue.length
                item.conditionSkip = !topicFlag // 段落和单行多行不能作为显示的条件，即skip为true; 没有设置显示条件的题不显示，即show为1且showJson有值；
                if (item.topicType === 'matrix-rate') {
                    item.matrixs.forEach((matrix) => {
                        topicFlag = matrix.value && matrix.value.length
                        matrix.conditionSkip = !topicFlag // 没有设置条件的矩阵组件不显示，即每行的value值为空
                    })
                }
            })
            this.topics = newIndexTopicsList
            this.setRelate() // 设置所有条件之前的关系
        },
        setRelate() {
            let num = 0
            this.topics.forEach((topic) => {
                if (topic.topicType === 'matrix-rate') {
                    topic.matrixs.forEach((matrix) => {
                        !matrix.conditionSkip ? num++ : null
                    })
                    return
                }
                !topic.conditionSkip ? num++ : null
            })
            num > 1 ? this.moreCondition = true : null
        },
        selectRelate() {
            this.relatePop = true
        },
        relateConfirm(value, index) {
            this.relateIndex = index
            this.relatePop = false
        },
        relateCancel() {
            this.relatePop = false
        },
        del(item, index) {
            if (item.topicType === 'matrix-rate') {
                let matrix = item.matrixs[index]
                matrix.conditionSkip = true
                matrix.value = []
                item.matrixs.splice(index, 1, matrix)
                this.dealRelate()
                return
            }
            item.conditionSkip = true
            item.showJsonValue = []
            this.dealRelate()
        },
        addCondition() {
            const topics = JSON.parse(JSON.stringify(this.topics))
            topics.forEach((topic) => {
                if (topic.topicType === 'matrix-rate') {
                    topic.matrixs && topic.matrixs.forEach((matrix) => {
                        matrix.conditionSkip = false
                    })
                    return
                }
                topic.conditionSkip = false
            })
            this.$store.commit("updateShowTopicList", topics)
            this.$store.commit("updateRelate", this.relateIndex)
            this.$router.push({
                name: 'show-condition',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                    type: this.type,
                },
            })
        },
        confirm() {
            let showJson = { list: [], relate: false,}
            this.topics.forEach((item, index) => {
                if (item.show !== '1') return
                if (item.topicType === 'matrix-rate') {
                    let conditions = []
                    item.matrixs.forEach((matrix, i) => {
                        if (!item.conditionSkip) return
                        conditions.push({
                            index: i,
                            value: matrix.value,
                        })
                    })
                    showJson.list.push({
                        id: item.topicCode,
                        config: 0,
                        type: item.topicType,
                        conditions,
                    })
                } else {
                    !item.conditionSkip && showJson.list.push({
                        id: item.topicCode,
                        config: item.config || 0,
                        conditions: item.showJsonValue,
                        type: item.topicType,
                    })
                }
            })
            showJson.relate = this.relateIndex
            this.$store.commit('updateShowJson', showJson.list.length ? JSON.stringify(showJson) : '')
            this.$store.commit('updateShowConfirm', true)
            this.$store.commit("updateRelate", this.relateIndex)
            if (this.topicId) {
                this.$router.back({
                    name: 'topic2',
                    params: {
                        pageId: this.pageId,
                        topicId: this.topicId,
                    },
                })
                return
            }
            this.$router.back({
                name: 'topic',
                params: {
                    type: this.type,
                    pageId: this.pageId,
                },
            })
        },
        select(item) {
            this.showPop = true
            this.popItem = item
        },
        onConfirm(value, index) {
            this.popItem.config = index
            this.showPop = false
        },
        onCancel() {
            this.showPop = false
        },
        dealRelate() {
            let index = 0
            this.topics.forEach((item) => {
                if (item.topicType === 'matrix-rate') {
                    item.matrixs ? index += item.matrixs.filter(matrix => !matrix.conditionSkip).length : null
                    return
                }
                !item.conditionSkip ? index++ : null
            })
            this.moreCondition =  index > 1 ? true : false
            this.relateIndex = this.moreCondition ? null : 0
        },
    },
}
</script>
<style scoped lang="scss">
    .add-condition{
        padding: .42rem;
        background: #fff;
        .tip{
            font-size: .34rem;
            color: #9298A8;
        }
        .topic{
            margin-top: .21rem;
            display: flex;
            align-items: center;
            font-size: .37rem;
        }
        .topic-title{
            flex: 1;
            color: #333;
            line-height: .56rem;
        }
        .add-btn{
            margin-left: 1.44rem;
            width: 2.45rem;
            height: .9rem;
            line-height: .9rem;
            background: #06B455;
            border-radius: .16rem;
            text-align: center;
            color: #fff;
        }
    }
    .condition-wrap{
        padding: 0.32rem;
        &.noMore{
            border-bottom: 1.75rem solid #f7f7f7;
        }
        .item{
            margin-bottom: .32rem;
            background: #fff;
            border-radius: .16rem;
            font-size: .37rem;
            .condition{
                padding: .42rem .42rem 0 .42rem;
            }
            .title-wrap{
                display: flex;
                align-items: center;
            }
            .topic-title{
                color: #222;
                flex: 1;
            }
            .matrix-title{
                margin-top: .42rem;
                margin-left: .21rem;
            }
            .topic-type{
                color: #9298A8;
            }
            .del{
                margin-left: .42rem;
                width: .45rem;
                cursor: pointer;
            }
            .tip{
                padding: 0 .42rem;
                height: 1.17rem;
                line-height: 1.17rem;
                background: #FBFBFC;
                color: #9298A8;
                font-size: .34rem;
            }
            .options{
                margin-top: .42rem;
            }
            .option{
                margin-bottom: .42rem;
                padding-left: .53rem;
                color: #5F6670;
                font-size: .32rem;
                line-height: .48rem;
            }
            .checkbox{
                padding: 0;
            }
            .checkbox-rule{
                background-color: #fbfbfc;
                align-items: center;
            }
            ::v-deep .me-cell__left-icon, .me-cell__right-icon{
                height: auto;
                position: relative;
                top: 1PX;
            }
            ::v-deep .me-cell--clickable {
                font-size: .34rem;
            }
        }
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    .topic-relate{
        border-bottom: 1.75rem solid #f7f7f7;
        background: #fff;
        color: #222222;
        font-size: .37rem;
        .relate-desc{
            padding-left: 0.42rem;
            line-height: 1.41rem;
        }
    }
</style>
